export default "__VITE_ASSET__44zq6q3OBHe76m6OuK8k5Q__"